import React, { useRef, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Spinner,
  Alert,
} from "reactstrap"; // Added Spinner, Alert
import { useNavigate, useParams } from "react-router";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../images/cnnmLogo.png";
import { BASE_URL } from "../config";
import dummyImg from "./images/profile-dummy.png";
import Biodataform from "./Biodataform";
const profilePlaceholder = 'https://placehold.co/150x180/EBF5FB/333?text=Photo';

const calculateAge = (dobString) => {
  if (!dobString) return "-";
  try {
    const birthDate = new Date(dobString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 0 ? age : "-";
  } catch (e) {
    console.error("Error calculating age:", e);
    return "-";
  }
};

const formatDOB = (dobString) => {
  if (!dobString) return "-";
  try {
    const date = new Date(dobString);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date provided for formatting:", dobString);
      return dobString;
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (e) {
    console.error("Error formatting DOB:", e);
    return dobString;
  }
};

const BioDataField = ({ label, value }) => {
  const labelStyle = {
    fontWeight: "500",
    color: "#e00211",
    paddingRight: "10px",
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    color: "#555",
    fontSize: "0.9rem",
    wordBreak: "break-word",
  };
  const rowStyle = {
    borderBottom: "1px solid #eee",
    padding: "6px 0",
    display: "flex",
    alignItems: "flex-start",
    minHeight: "30px",
  };

  return (
    <div style={rowStyle}>
      <div style={{ width: "45%", ...labelStyle, flexShrink: 0 }}>
        {label} :{" "}
      </div>{" "}
      {/* Prevent label shrinking */}
      <div style={{ width: "55%", ...valueStyle }}>{value || "-"}</div>
    </div>
  );
};

const BioDataSection = ({ children }) => {
  const sectionStyle = {
    marginBottom: "1rem",
    paddingBottom: "0.5rem",
  };
  return <div style={sectionStyle}>{children}</div>;
};

const Dummydetails = () => {
  const navigate = useNavigate();

  const pdfRef = useRef();
  const [userData, setUserData] = useState(null);
  const [apiRawData, setApiRawData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  console.log(id);
  function convertRailwayToNormalTime(time) {
    // Expects time format as "HH:mm" (e.g., "13:45", "09:30", "00:00")
    const [hoursStr, minutesStr] = time.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = minutesStr.padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
  
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
  
    return `${hours}:${minutes} ${ampm}`;
  }
  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const registered=sessionStorage.getItem('registered')
        
        if(registered=="true"  ){
            navigate('/verify-payment')
        }
        else if(registered=="payment"){
            navigate('/payment')
        }
        else if (!loggedInUser) {
            navigate('/SignUp');
        } 
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${BASE_URL}/getUserById.php?id=${id}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        if (result.status === "success" && result.data) {
          const apiData = result.data;
          setApiRawData(apiData); // Store raw data
          const mappedUser = {
            dasa:apiData.dasa,
            dasa_years:apiData.dasa_years,
            dasa_months:apiData.dasa_months,
            dasa_days:apiData.dasa_days,
            id: apiData.id,
            contact_person:apiData.reg_name!=undefined&&apiData.reg_name!=null&&apiData.reg_name!=""?true:false,
            reg_name:apiData.reg_name,
            reg_phone:apiData.reg_phone,
            relation:apiData.relation,
            regNo: `CNNM${String(apiData.id).padStart(5, "0")}`, // Example format, adjust if needed
            fullname: apiData.fullname,
            marital_status: apiData.marital_status,
            gender: apiData.gender,
            dob: formatDOB(apiData.dob),
            age: calculateAge(apiData.dob),
            dob_time: convertRailwayToNormalTime(apiData.dob_time) || "-",
            birth_place: apiData.birth_place || "-",
            order_of_birth: apiData.birth_order || "-",
            gothram: "-",
            mother_tongue: apiData.mother_tongue || "-",
            rashi: apiData.rashi || "-",
            star: apiData.star || "-",
            paadham: apiData.paadham || "-",
            laknam: apiData.lagnam||"-",
            dossam: `Sevvai: ${apiData.sevaai_dhosam || "No"}, Sarpa: ${
              apiData.sarpam_dhosam || "No"
            }, Raagu/Kethu: ${apiData.raagu_dhosam || "No"}`,
            caste: `${apiData.caste || ""}${
              apiData.sub_caste ? ` (${apiData.sub_caste})` : ""
            }`,
            height: apiData.height ? `${apiData.height}` : "-",
            complexion: apiData.complexion,
            body_type: "-",
            education: apiData.education || "-",
            job_type: apiData.job_type || "-",
            company_name:
              apiData.company_name === "NIL" || !apiData.company_name
                ? "-"
                : apiData.company_name,
            salary:
              apiData.salary === "NIL" || !apiData.salary
                ? "N/A"
                : `₹ ${apiData.salary}`,
            work_place:
              apiData.work_place === "NIL" || !apiData.work_place
                ? "-"
                : apiData.work_place,
            diet: "-",
            physical_status: "Normal",
            
              
            father_job: apiData.father_desigination || "-",
            mother_job: apiData.mother_desigination || "-",
            navamsam: apiData.navamsam || "-",
            rasi:apiData.rasi || "-",
            // Individual dosham fields might be useful too
            sevaai_dhosam: apiData.sevaai_dhosam || "Not Specified",
            sarpam_dhosam: apiData.sarpam_dhosam || "Not Specified",
            raagu_dhosam: apiData.raagu_dhosam || "Not Specified",
            mobile_1: `${apiData.mobile_1 || "-"}${
              apiData.mobile_2 ? ` / ${apiData.mobile_2}` : ""
            }`,
            whatsapp: apiData.whatsapp || "-",
            email: apiData.email || "-",
            address:
              `${apiData.address || ""} ${apiData.living_place || ""}, ${
                apiData.state || ""
              } - ${apiData.pin_code || ""}, ${apiData.country || ""}`
                .replace(/ ,/g, ",")
                .replace(/ - ,/g, ",")
                .replace(/ , $/, "")
                .trim() || "-", // Clean up potential extra commas/spaces
            living_place: apiData.living_place || "-",
            pin_code: apiData.pin_code || "-",
            country: apiData.country || "-",
            expectations: apiData.expectations || "-",
            // Expectation fields not present in API response
            exp_qualification: "-",
            exp_job: "-",
            exp_income: "-",
            exp_diet: "-",
            exp_marital_status: "-",
            exp_other: "-",
            registration_date: apiData.registration_date
              ? apiData.registration_date.split(" ")[0]
              : "-",
            father: apiData.father_name || "-",
            mother: apiData.mother_name || "-",
            // Sibling Counts
            brother_total: parseInt(
              apiData.brother === "-" ? 0 : apiData.brother || 0,
              10
            ),
            brother_married: parseInt(
              apiData.brother_married === "-"
                ? 0
                : apiData.brother_married || 0,
              10
            ),
            father_qualification:apiData.father_qualification ||"-",
            mother_qualification:apiData.mother_qualification ||"-",
            sister_total: parseInt(
              apiData.sister === "-" ? 0 : apiData.sister || 0,
              10
            ),
            sister_married: parseInt(
              apiData.sister_married === "-" ? 0 : apiData.sister_married || 0,
              10
            ),
            brother_elder: "-",
            brother_younger: "-",
            sister_elder: "-",
            sister_younger: "-",
            // profile_photo1: `${BASE_URL}/uploads/profile_photo1/${apiData.profile_photo1}`,
            profile_photo1: apiData.profile_photo1
                ? `${BASE_URL}/uploads/profile_photo1/${apiData.profile_photo1}`
                : profilePlaceholder,
                profile_photo2: apiData.profile_photo2
                ? `${BASE_URL}/uploads/profile_photo2/${apiData.profile_photo2}`
                : profilePlaceholder,
            profile_photo3:apiData.profilePhoto? `${BASE_URL}/uploads/profiles/${apiData.profilePhoto}`
            : profilePlaceholder,
            nativity: apiData.birth_place || "-", // Using birth place as nativity
            any_other_details: "-", // Field not present in API response
            // contact_person: apiData.father_name || "Parent", // Default contact
          };
          // somewhere in your mapping logic…
          if(apiData.father.toLowerCase()!=="alive"){
            mappedUser.father = `${apiData.father_name} (Late)`;
          }
          else{
            mappedUser.father = `${apiData.father_name} (Alive)`;
          }
          if(apiData.mother.toLowerCase()!=="alive"){
            mappedUser.mother = `${apiData.mother_name} (Late)`;
          }
          else{
            mappedUser.mother = `${apiData.mother_name} (Alive)`;
          }


          mappedUser.brother_married = Math.max(
            0,
            mappedUser.brother_total - mappedUser.brother_married
          );
          mappedUser.sister_married = Math.max(
            0,
            mappedUser.sister_total - mappedUser.sister_married
          );

          setUserData(mappedUser);
        } else {
          throw new Error(
            result.message || "API returned success:false or data missing."
          );
        }
      } catch (err) {
        console.error("API Fetch Error:", err);
        setError(
          err.message ||
            "Failed to fetch data. Please check the network connection or API endpoint."
        );
        setUserData(null);
        setApiRawData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleDownloadPdf = () => {
    if (!userData) {
      alert("User data not available to generate PDF.");
      return;
    }
    const input = pdfRef.current;
    if (!input) {
      console.error("PDF reference is not available.");
      return;
    }

    const originalBorderStyle = input.style.border;
    input.style.border = "none";

    html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff",
    })
      .then((canvas) => {
        input.style.border = originalBorderStyle;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = imgProps.width;
        const imgHeight = imgProps.height;

        const margin = 10;
        const availableWidth = pdfWidth - 2 * margin;
        const availableHeight = pdfHeight - 2 * margin;
        const ratio = Math.min(
          availableWidth / imgWidth,
          availableHeight / imgHeight
        );

        const effectiveImgWidth = imgWidth * ratio;
        const effectiveImgHeight = imgHeight * ratio;

        const imgX = (pdfWidth - effectiveImgWidth) / 2;
        const imgY = margin;
        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          effectiveImgWidth,
          effectiveImgHeight
        );
        pdf.save(
          `${userData.regNo || "biodata"}_${userData.fullname || "user"}.pdf`
        );
      })
      .catch((error) => {
        input.style.border = originalBorderStyle;
        console.error("Error generating PDF:", error);
        alert("Error generating PDF. Check the console for details.");
      });
  };

  if (loading) {
    return (
      <Container className="userfullList-details my-4 text-center">
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        <p>Loading User Data...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="userfullList-details my-4">
        <Alert color="danger">
          <strong>Error:</strong> {error}
        </Alert>
      </Container>
    );
  }

  if (!userData) {
    return (
      <Container className="userfullList-details my-4">
        <Alert color="warning">No user data available.</Alert>
      </Container>
    );
  }

  return (
    <Container className="userfullList-details my-4">
      <Row className="justify-content-center">
        <Col md={12} lg={10} xl={9}>
          {" "}
          <Card className="shadow-sm">
            <CardBody>
              <Biodataform userData={userData} ref={pdfRef} />
              {/* // old dev code  */}
              {/* End of pdfRef div */}
              {/* Download Button (Outside the PDF content area) */}
              {/* <div className="text-center mt-4">
                <Button
                  color="success"
                  onClick={handleDownloadPdf}
                  disabled={!userData}
                >
                  <i className="bi bi-download me-2"></i> Download as PDF
                </Button>
              </div> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dummydetails;
